import { isNumber } from 'lodash';

import { TXTCLI_Required } from '../translations';
import type { Error } from '../types';

export const requiredNumber =
  (message: Error['message'] = TXTCLI_Required) =>
  (value: string) => ({
    valid: isNumber(value),
    message
  });
